
import { useContext } from '@nuxtjs/composition-api';
import useCheckout from '@/composable/checkout/useCheckout';

export default {
  name: 'TlmCheckoutCustomerContactInfoFields',
  props: {
    playEmailInUseError: {
      type: Object,
      default: () => {
      }
    }
  },
  setup() {
    const { app } = useContext()
    const { state } = useCheckout(app)
    const { customerInfo } = state;
    const { contactInfo } = customerInfo;
    return {
      contactInfo
    }
  }
}
